import { render } from "./WordPressPostTrigger.vue?vue&type=template&id=9d3d2c0e"
import script from "./WordPressPostTrigger.vue?vue&type=script&lang=js"
export * from "./WordPressPostTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__